import styled from 'styled-components';
import { Button } from 'react-bootstrap';

export const GearAssetsHeaderMain = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`;

export const OnboardGearSection = styled.div`
    height: 160px;
    width: 30%;
    padding: 8px;
    box-shadow: 4px 4px 8px rgba(16, 24, 40, 0.1);
    border: 0.5px solid #D3D3D3;
    border-radius: 8px;

    display: flex;
    flex-direction: column;
`;

export const OnboardGearTitle = styled.div`
    width: 100%;
    padding: 8px;
    font-weight: 600;
    font-size: 24px;
`;

export const OnboardGearBody = styled.div`
    width: 100%;
    padding: 8px;
    font-weight: 400;
    font-size: 15px;
    color: #667085;
`;

export const OnboardGearFooter = styled.div`
    width: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
    margin-top: auto;
`;

export const OnboardGearBtn = styled(Button)`
    background: white;
    color: #5D3FD3;
    border-color: white;

    padding: 6px 8px;
    margin-right: 5px;

    &:hover {
        background: #5D3FD3;
        color: white;
        border-color: white;
    }
`;
